module["exports"] = [
  "1###",
  "2###",
  "3###",
  "4###",
  "5###",
  "6###",
  "7###",
  "8###",
  "9###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_CH/address/postcode.js
// module id = 632
// module chunks = 0